module.exports = __webpack_public_path__ + "img/cloud1.c16271bf.svg";